import {Spin} from '@osui/ui';
import styled from 'styled-components';
const WrapDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;
export default function PageLoading() {
    return (
        <WrapDiv>
            <Spin />
        </WrapDiv>
    );
}
